import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { SecretRegisterClient } from "@/features/secrets/SecretRegisterClient";
import { getSecretRegister, secretKeys } from "@/features/secrets/secrets.api";
import { firstAllowedRoute } from "@/lib/auth";

// Beheer → Geheimen (docs/geheimen.md): the secrets this environment leans on and when they expire. Admins only.

export const Route = createFileRoute("/_shell/secrets")({
  beforeLoad: ({ context }) => {
    if (!context.session.roles.includes("admin")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: SecretsScreen,
});

function SecretsScreen() {
  const { session } = Route.useRouteContext();
  const register = useQuery({ queryKey: secretKeys.all, queryFn: getSecretRegister });
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Secrets">
      <SecretRegisterClient register={register.data} userId={session.userId} isFetching={register.isFetching} isLoading={register.isLoading} />
    </div>
  );
}
